var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteNewIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.4H8.11111M8.11111 8.4H17M8.11111 8.4V16.8C8.11111 17.1183 8.22817 17.4235 8.43655 17.6485C8.64492 17.8736 8.92754 18 9.22222 18H14.7778C15.0725 18 15.3551 17.8736 15.5635 17.6485C15.7718 17.4235 15.8889 17.1183 15.8889 16.8V8.4H8.11111ZM9.77778 8.4V7.2C9.77778 6.88174 9.89484 6.57652 10.1032 6.35147C10.3116 6.12643 10.5942 6 10.8889 6H13.1111C13.4058 6 13.6884 6.12643 13.8968 6.35147C14.1052 6.57652 14.2222 6.88174 14.2222 7.2V8.4M10.8889 11.4V15M13.1111 11.4V15",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteNewIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete-new-icon.4850f3786759c1770117cc3d111f2e43.svg";